/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    class UdfSearchController implements angular.IComponentController {

        static $inject = [];

        udfFieldForm: angular.IFormController;
        criteria: {
            [key: string]: string | number | boolean;
        };
        name: string;
        shortcutKey: string;
        searchKey: string;
        shortcut: string;
        search: string;

        private _currentValue: string;

        get currentValue(): string {
            return this._currentValue;
        }

        set currentValue(value: string) {
            this._currentValue = value;
            if (/^[a-zA-Z0-9]{2,6}=(.+)/.test(this._currentValue)) {
                let _tmp = this._currentValue.match(/([a-zA-Z0-9]{2,6})=(.+)/);
                this.criteria[this.shortcutKey] = _tmp[1];
                this.criteria[this.searchKey] = _tmp[2];
                this.udfFieldForm[this.name].$setValidity('udfsearch', true)
            } else {
                this.criteria[this.shortcutKey] = null;
                this.criteria[this.searchKey] = null;
                this.udfFieldForm[this.name].$setValidity('udfsearch', !this._currentValue.length)
            }
        }

        $onInit(){
            if (this.criteria[this.shortcutKey] && this.criteria[this.searchKey]){
                this._currentValue = `${this.criteria[this.shortcutKey]}=${this.criteria[this.searchKey]}`
            }
        }
    }

    const udfSearch: angular.IComponentOptions = {
        templateUrl: 'app/components/controls/udfSearch/udfSearch.template.html',
        bindings: {
            contentKey: '@',
            tabIndex: '@',
            name: '@',
            disabled: '=ngDisabled',
            criteria: '=',
            shortcutKey: '@',
            searchKey: '@',
        },
        controller: UdfSearchController
    };

    angular.module("meevo.components.controls")
        .component("meevoUdfSearch", udfSearch);
}